/**
 * The staff AI assistant, mounted in Layout.tsx: the top-bar button and the panel it opens.
 *
 * The panel is ClinVea Copilot (components/ai/copilot, medopd-docs 154). The names stay so Layout and its tests keep
 * one mount point; the old /api/ai/chat/message panel is gone.
 */
import { IconButton, Tooltip } from '@mui/material';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CopilotPanel } from './copilot/CopilotPanel';

export { CopilotPanel as AiStaffChatPanel };

/** Top-bar button that opens and closes the Copilot panel. */
export function AiChatFab({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation('ui');
  return (
    <Tooltip title={t('aiAssistant')}>
      <IconButton
        onClick={onClick}
        aria-label={t('aiAssistant')}
        sx={{
          color: 'text.secondary',
          '&:hover': { color: 'primary.main' },
        }}
      >
        <Sparkles size={18} />
      </IconButton>
    </Tooltip>
  );
}
